import { useState, useEffect, useCallback } from 'react';
import { PointOfSaleItem } from '../model/pointofsale/PointOfSaleItem';
import { sortPosItems } from '../utils/posItemUtils';

const STORAGE_KEY = 'posItemSortType';

/**
 * Custom hook for managing POS item sorting state and logic
 * @param defaultSortType The default sort type if no preference is saved
 * @returns An object with sortType, handleSortTypeChange, and sortItems function
 */
export const usePosItemSorting = (defaultSortType: 'rank' | 'mostPopular' = 'mostPopular') => {
  const [sortType, setSortType] = useState<'rank' | 'mostPopular'>(defaultSortType);

  // Load sort preference from localStorage on mount
  useEffect(() => {
    const savedSortType = localStorage.getItem(STORAGE_KEY);
    if (savedSortType === 'rank' || savedSortType === 'mostPopular') {
      setSortType(savedSortType);
    }
  }, []);

  const handleSortTypeChange = useCallback((value: 'rank' | 'mostPopular') => {
    setSortType(value);
    localStorage.setItem(STORAGE_KEY, value);
  }, []);

  const sortItems = useCallback(<T extends PointOfSaleItem>(items: T[]): T[] => {
    return sortPosItems(items, sortType);
  }, [sortType]);

  return {
    sortType,
    handleSortTypeChange,
    sortItems,
  };
};

